import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  cancelLeaveRequest: ["leave_id"],
  cancelLeaveSuccess: ["leavedata"],
  cancelLeaveFailure: ["status"],
});

export const CancelLeaveTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  status: null,
  leave_id: null,
  leavedata: null,
});

export const CancelLeaveSelectors = {
  getData: (state: any) => state.cancelLeave.data,
  isFetching: (state: any) => state.cancelLeave.fetching,
  isSuccess: (state: any) => state.cancelLeave.success,
  hasError: (state: any) => state.cancelLeave.error,
};

export const request = (state: any, action: any) => {
  const { leave_id } = action;
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leave_id,
    status: null,
    leavedata: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { leavedata } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    leavedata,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CANCEL_LEAVE_REQUEST]: request,
  [Types.CANCEL_LEAVE_SUCCESS]: success,
  [Types.CANCEL_LEAVE_FAILURE]: failure,
});
